<script setup lang="ts">
import { onMounted, onUnmounted, ref, shallowRef } from 'vue'
import ScoringCalculator from '@/features/scoring/ScoringCalculator.vue'
import UFPMDashboard from '@/features/ufpm/components/UFPMDashboard.vue'
import type { UFPMMember } from '@/features/ufpm/lib/types'

const ufpmEnabled = ref(false)
const members = shallowRef<readonly UFPMMember[]>([])

function refreshMembers(): void {
  members.value = window.ufpmTools?.getMembers?.() ?? []
}

function onModeChanged(event: Event): void {
  const enabled = !!(event as CustomEvent).detail?.enabled
  ufpmEnabled.value = enabled
  if (enabled) refreshMembers()
}

function onMembersChanged(event: Event): void {
  const next = (event as CustomEvent).detail?.members as UFPMMember[] | undefined
  if (next) members.value = next
}

onMounted(() => {
  ufpmEnabled.value = window.ufpmTools?.isModeEnabled?.() ?? false
  refreshMembers()
  window.addEventListener('ptr:ufpm-mode-changed', onModeChanged)
  window.addEventListener('ptr:ufpm-members-changed', onMembersChanged)
})

onUnmounted(() => {
  window.removeEventListener('ptr:ufpm-mode-changed', onModeChanged)
  window.removeEventListener('ptr:ufpm-members-changed', onMembersChanged)
})
</script>

<template>
  <UFPMDashboard v-if="ufpmEnabled" :members="members" />
  <ScoringCalculator v-else />
</template>